import { TDoor } from 'shared/types/doors';
import { DoorContent } from '../DoorContent';

interface ISecondDoorContentProps extends TDoor {
  secondBtn?: {
    btnText: string;
    onSecondBtn: VoidFunction;
  };
  firstBtnClicked?: boolean;
}

export const SeventhDoorContent: React.FC<ISecondDoorContentProps> = props => {
  return (
    <DoorContent btnText="Присоединиться к сообществу" {...props}>
      <div>Всё, что нужно сделать — вступить в сообщество хостов в Telegram. </div>
      <div>
        А в благодарность за вступление мы сразу отправим вам эксклюзивный стикерпак для хостов. Мы создали его таким,
        чтобы вы могли легко и с юмором общаться с коллегами🤌
      </div>
      <div>
        <i>Присоединяйтесь к комьюнити хостов и пополняйте свою коллекцию полезными стикерами!</i>
      </div>
    </DoorContent>
  );
};
